import React, { PureComponent } from 'react';
import Minus from '../tables/Minus';
import ImportantEvent from '../tables/ImportantEvent';
import MajorProgramViolation from '../tables/MajorProgramViolation';
import ComplaintMinusScore from '../tables/ComplaintMinusScore';

class MinusContent extends PureComponent {
    render() {
        const { loading, restData } = this.props;
        const { minusScores, majorEvents, majorViolates, complaintRecords } = restData;
        return (
            <div>
                <Minus loading={loading} data={minusScores} />
                <ImportantEvent loading={loading} data={majorEvents} />
                <MajorProgramViolation loading={loading} data={majorViolates} />
                <ComplaintMinusScore loading={loading} data={complaintRecords} />
            </div>
        );
    }
}

export default MinusContent;


// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/components/MinusContent.js